import { VStack } from "@gluestack-ui/themed";
import Spinner from "../Spinner";

export const FixedLoading = () => {
  return (
    <VStack
      fixed
      top={0}
      left={0}
      width="$100vw"
      height="$100vh"
      alignContent="center"
      justifyContent="center"
      backgroundColor="#FFFFFF99"
    >
      <Spinner />
    </VStack>
  );
};

export default FixedLoading;
